import { render, staticRenderFns } from "./imgFile.vue?vue&type=template&id=6ee298c0&scoped=true"
import script from "./imgFile.vue?vue&type=script&lang=js"
export * from "./imgFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee298c0",
  null
  
)

export default component.exports